/**
 * Header de autenticacao para chamadas ao backend.
 *
 * O token normalmente ja viaja em `axios.defaults.headers.common.Authorization`,
 * definido por `setSession` (src/utils/jwt.js) no login e na inicializacao do
 * JWTContext. Mas o interceptor global de `src/api/axios.config.js` tem a linha
 * do Authorization comentada, e as rotas que exigem sessao passaram a depender
 * dela — entao passar o header explicitamente elimina a duvida. Mesmo padrao ja
 * usado em actions/usuarios/actionSalvarCredenciaisImoview.js.
 *
 * Devolve objeto vazio quando nao ha token, para nao enviar "Bearer undefined".
 */
export function authHeaders(extra = {}) {
    const token = localStorage.getItem('token');
    return token ? { ...extra, Authorization: `Bearer ${token}` } : { ...extra };
}

export default authHeaders;
